import React from 'react';
import {
  Button, Card, Tag, Typography, message,
} from 'antd';
import Icon from '@mdi/react';
import { mdiApi, mdiContentCopy, mdiMessageTextOutline } from '@mdi/js';

const { Title, Text, Paragraph } = Typography;

// Каждый промт проверен на живом биоме. endpoints — те вызовы, на которые
// агент реально опирается, отвечая на этот запрос.
const PROMPT_EXAMPLES = [
  {
    key: 'grant-service-access',
    text: 'Подключи сотрудника [логин] к сервису [сервис]: покажи, что у него есть сейчас, '
      + 'добавь в листинг-группу сервиса и выдай нужные permactions. '
      + 'Потом убедись, что изменения доехали до самого сервиса, и покажи, что стало.',
    write: true,
    endpoints: [
      'POST /get/actors',
      'POST /get/permactions/actor',
      'POST /update/actor/group',
      'POST /set/permactions/actor',
      'GET /synchronization/health/',
    ],
  },
  {
    key: 'offboarding',
    text: 'Сотрудник [логин] уходит. Собери всё, что у него есть: группы, личные permactions, '
      + 'где он админ сервиса. Покажи мне список, забань его и убедись, что бан доехал до всех сервисов. '
      + 'Актора не удаляй — удаление необратимо и разъедется по всему биому.',
    write: true,
    endpoints: [
      'POST /get/actors',
      'POST /get/permactions/actor',
      'POST /permactions/get_actors_with_perms_on_service',
      'POST /update/actor/ban',
      'GET /synchronization/health/',
    ],
  },
  {
    key: 'ban-users',
    text: 'Забань пользователей [логин 1] и [логин 2]. Сначала покажи их карточки и убедись, '
      + 'что они ещё не в BAN: эндпоинт переключает состояние, и на забаненном он бан снимет. '
      + 'После бана проверь, что пакеты разъехались по сервисам.',
    write: true,
    endpoints: [
      'POST /get/actors',
      'POST /update/actor/ban',
      'GET /synchronization/health/',
    ],
  },
  {
    key: 'service-admin',
    text: 'Сделай [логин] администратором только сервиса [сервис], без биом-админства. '
      + 'Сначала покажи, что он может там сейчас, потом выдай права и покажи разницу.',
    write: true,
    endpoints: [
      'POST /permactions/get_actors_with_perms_on_service',
      'POST /service-specific-admin',
    ],
  },
  {
    key: 'group-rebalance',
    text: 'У [логин] конфликт групп: доступ к [сервис] решает не та группа, что нужно. '
      + 'Найди, какая группа сейчас перевешивает, и сделай так, чтобы решала [группа]. '
      + 'Помни: права не суммируются, решает одна самая тяжёлая группа, а вес должен остаться уникальным.',
    write: true,
    endpoints: [
      'logic_description',
      'POST /get/actors',
      'POST /get/permactions/group',
      'POST /set/permactions/group',
      'POST /update/actor',
    ],
  },
  {
    key: 'stuck-queue',
    text: 'У сервиса [сервис] копится очередь синхронизации. Разберись, какие пакеты застряли '
      + 'и почему, и повтори отправку тех, что можно. Очередь целиком в ответ не выгружай — '
      + 'там бывают десятки тысяч строк, сверни до сводки по типам действий.',
    write: true,
    endpoints: [
      'GET /synchronization/health/',
      'POST /synchronization/sync_package_for_service/',
      'POST /synchronization/package_retry',
    ],
  },
  {
    key: 'force-sync',
    text: 'Проверь очередь синхронизации по биому. Если какой-то живой сервис отстал — '
      + 'покажи, насколько, и запусти для него принудительную синхронизацию. '
      + 'Мёртвые сервисы не трогай, сначала скажи мне о них.',
    write: true,
    endpoints: [
      'GET /synchronization/health/',
      'POST /synchronization/forced_for_service',
    ],
  },
  {
    key: 'access-denied',
    text: 'Пользователю [логин] отказано в доступе на [сервис]. Пройди правила резолюции '
      + 'по порядку — бан, личное право, самая тяжёлая группа, дефолт сервиса — и скажи, '
      + 'на каком шаге он споткнулся и что именно поменять, чтобы доступ появился.',
    endpoints: [
      'logic_description',
      'POST /get/actors',
      'POST /get/permactions/actor',
      'POST /get/permactions/group',
    ],
  },
  {
    key: 'banned-list',
    text: 'Сколько акторов сейчас в группе BAN? Перечисли их логины и по логам определи, '
      + 'когда и кто их забанил.',
    endpoints: [
      'POST /get/actors',
      'POST /get_logs',
    ],
  },
  {
    key: 'learn-entities',
    text: 'Объясни, как в auth54 устроены сущности: какие бывают типы акторов, где хранится '
      + 'членство в группах, чем permaction отличается от группового права и в каком порядке '
      + 'резолвится доступ. Зачем нужен weight и почему права не суммируются. '
      + 'Покажи на живых примерах из биома — с реальными группами и их весами.',
    endpoints: [
      'logic_description',
      'POST /get/actors',
    ],
  },
  {
    key: 'biome-admins',
    text: 'Покажи всех биом-админов и отдельно service-specific админов по каждому сервису. '
      + 'Учти, что в группе ADMIN лежат не только люди, но и сервис-акторы — раздели их.',
    endpoints: [
      'POST /get/actors',
      'POST /permactions/get_actors_with_perms_on_service',
    ],
  },
  {
    key: 'service-access',
    text: 'Кто имеет доступ к Entity и на каком уровне. Разложи по категориям: '
      + 'root, биом-админы, админы сервиса, группы, обычные пользователи.',
    endpoints: [
      'POST /permactions/get_actors_with_perms_on_service',
    ],
  },
  {
    key: 'sync-health',
    text: 'Проверь состояние синхронизации по биому. Для каждого сервиса: сколько пакетов висит, '
      + 'возраст самого старого, сколько остановлено, когда последняя подтверждённая доставка. '
      + 'Кто в критикале — вынеси наверх.',
    endpoints: [
      'GET /synchronization/health/',
    ],
  },
  {
    key: 'forced-sync-logs',
    text: 'Покажи по каждому сервису последние форс-синки: когда, кем, в каком режиме, '
      + 'успешно или нет. Инициаторов резолвни из uuid в логины.',
    endpoints: [
      'POST /healthcheck/forced_syncrotization_logs',
      'POST /get/actors',
    ],
  },
  {
    key: 'broken-service',
    text: 'Vpn54cluster не принимает пакеты. Разбери почему: проверь связь с доменом, '
      + 'пару ключей, версию auth_perms, и покажи, сколько раз аус пытался доставить.',
    endpoints: [
      'POST /depended_service/status/',
      'POST /healthcheck/check_key_pair',
      'POST /healthcheck/get_versioning_info_for_service',
    ],
  },
];

function McpPromptExamples() {
  const copy = (value) => {
    navigator.clipboard.writeText(value);
    message.success('Промт скопирован');
  };

  return (
    <div>
      <Title level={4} className="mb-1">
        <Icon path={mdiMessageTextOutline} size={1} className="mr-2 align-middle" />
        Prompt Examples
      </Title>
      <Paragraph type="secondary">
        Готовые запросы для проверки доступов и синхронизации. Под каждым — API, на которое
        опирается агент.
      </Paragraph>

      {PROMPT_EXAMPLES.map((item) => (
        <Card key={item.key} size="small" className="mb-3">
          <div className="d-flex align-items-start justify-content-between">
            <div className="mr-3">
              <Text strong>{item.text}</Text>
              <div className="mt-2">
                {item.write && (
                  <Tag color="volcano" className="mb-1">
                    изменяет данные
                  </Tag>
                )}
                {item.endpoints.map((endpoint) => (
                  <Tag key={endpoint} color="blue" className="mb-1">
                    <Icon path={mdiApi} size={0.6} className="mr-1 align-middle" />
                    <span style={{ fontFamily: 'monospace' }}>{endpoint}</span>
                  </Tag>
                ))}
              </div>
            </div>
            <Button
              size="small"
              icon={<Icon path={mdiContentCopy} size={0.7} />}
              onClick={() => copy(item.text)}
              style={{ flexShrink: 0 }}
            >
              Копировать
            </Button>
          </div>
        </Card>
      ))}
    </div>
  );
}

export default McpPromptExamples;
